module.exports = __webpack_public_path__ + "img/T921.ac790044.jpg";